<template>
  <div class="EditTodoTemplates">
    <EditTodoTemplate v-for="tpl in currentProjectTodoTemplates" :key="tpl._id" :todoTemplate="tpl" />
    <img class="icon right" @click="createTodoTemplate()" src="static/icon/H2BOON-list-plus.png" />
    <span class="addnew">
      {{ $t('Add New') }}
    </span>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import EditTodoTemplate from './EditTodoTemplate';

export default {
  name: 'EditTodoTemplates',
  metaInfo() {
    return {
      title: this.$t('Todo Templates'),
    };
  },
  data() {
    return {};
  },
  methods: {
    ...mapActions(['loadProject', 'addTodoTemplate']),
    createTodoTemplate: function () {
      this.addTodoTemplate({ projectId: this.currentProject._id });
    },
  },
  computed: {
    ...mapGetters(['hasSimplePermissions', 'currentProject', 'currentProjectTodoTemplates']),
  },
  components: {
    EditTodoTemplate,
  },
};
</script>

<style scoped>
.EditTodoTemplates {
  /* background: rgb(10,29,46); */
  /* background: linear-gradient(90deg, rgba(10,29,46,1) 0%, rgba(10,29,46,1) 70%, rgba(32,53,72,1) 100%); */
  color: #fff;
  padding: 20px;
  min-height: 100vh;
}

.icon {
  width: 25px;
}

.addnew {
  margin-left: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/project/EditTodoTemplates.vue